import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {MatLegacyChipInputEvent as MatChipInputEvent} from '@angular/material/legacy-chips';


export type MaterialColor = 'primary' | 'accent' | 'warn';

export interface Item {
    name: string;
}

@Component({
    selector: 'app-chips',
    templateUrl: 'chips.component.html',
    styleUrls: ['chips.component.scss'],
})
export class ChipsComponent {
    @Input() Value: UntypedFormControl;
    Visible = true;
    Selectable = false;
    @Input() Removable = false;
    AddOnBlur = true;
    @Input() Color: MaterialColor = 'primary';
    @Input() InputEnabled = false;
    @Input() Placeholder = 'Item';
    readonly SeparatorKeysCodes: number[] = [ENTER, COMMA];

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;

        // Add item
        if ((value || '').trim()) {
            this.Value.value.push(value);
            this.Value.updateValueAndValidity();
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(item: string): void {
        const index = this.Value.value.indexOf(item);

        if (index >= 0) {
            this.Value.value.splice(index, 1);
            this.Value.updateValueAndValidity();
        }
    }
}
